/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Haslunchbreak2Inputs */

const en__field_haslunchbreak2 = /** @type {(inputs: _Field_Haslunchbreak2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lunchbreak exists`)
};

const de__field_haslunchbreak2 = /** @type {(inputs: _Field_Haslunchbreak2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagspause vorgesehen`)
};

/**
* | output |
* | --- |
* | "lunchbreak exists" |
*
* @param {_Field_Haslunchbreak2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_haslunchbreak2 = /** @type {((inputs?: _Field_Haslunchbreak2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Haslunchbreak2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_haslunchbreak2(inputs)
	return de__field_haslunchbreak2(inputs)
});
export { _field_haslunchbreak2 as "_field_hasLunchBreak" }